export interface PlannedMeal {
  name: string
  calories: number
  protein: number
  carbs: number
  fat: number
}

/**
 * Converts an item from a coach-authored meal plan into the exact shape used by
 * the client's daily nutrition log. Keeping this mapping explicit makes the
 * planned meal action usable from web and mobile without silently changing
 * macros or adding undocumented defaults.
 */
export const makePlannedMeal = (meal: PlannedMeal): PlannedMeal => ({
  name: meal.name,
  calories: meal.calories,
  protein: meal.protein,
  carbs: meal.carbs,
  fat: meal.fat,
})
